var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-search",
  "use": "ring-icon-search-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"ring-icon-search\"><path d=\"M14.069 12.737l-3.482-3.482a5.736 5.736 0 1 0-1.967 1.569l3.681 3.681a.56.56 0 0 0 .793 0l.975-.975a.56.56 0 0 0 0-.793zM1.937 5.701a4.2 4.2 0 1 1 4.201 4.2 4.205 4.205 0 0 1-4.2-4.2z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id